import React from 'react';
import { RunStatusDot, execStatusLabel } from 'features/agents/lib/status';
import { timeAgo, formatDuration, formatDate } from 'features/agents/lib/format';
import { triggerMeta } from 'features/agents/lib/triggerMeta';
import { tableHeaderRowClass, tableHeaderCellClass, tableRowClass, tableDataCellClass } from 'features/activity/styles/dataTableStyles';
import 'features/agents/runs/runs.css';

/** Who started a run: a person (manual or retry) or the agent's own trigger. */
export function startedBy(run) {
  return run.triggered_by ? 'User' : 'Automatic';
}

export default function RunsTable({ rows, selectedId, onOpen }) {
  return (
    <div className="overflow-hidden rounded-md border border-[color:var(--border-default)] bg-surface shadow-token-sm">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[700px] text-left">
          <thead>
            <tr className={tableHeaderRowClass}>
              <th scope="col" className={tableHeaderCellClass}>Status</th>
              <th scope="col" className={tableHeaderCellClass}>Trigger</th>
              <th scope="col" className={tableHeaderCellClass}>Version</th>
              <th scope="col" className={tableHeaderCellClass}>Steps</th>
              <th scope="col" className={tableHeaderCellClass}>Duration</th>
              <th scope="col" className={tableHeaderCellClass}>Started</th>
              <th scope="col" className={tableHeaderCellClass}>By</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const meta = triggerMeta(r.trigger_type);
              const TriggerIcon = meta.Icon;
              const failed = r.status === 'failed';
              return (
                <tr
                  key={r.id}
                  tabIndex={0}
                  data-testid="run-row"
                  aria-selected={selectedId === r.id}
                  onClick={() => onOpen(r)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(r); } }}
                  className={`${tableRowClass} outline-none focus-visible:bg-surface-hover ${selectedId === r.id ? 'bg-surface-hover' : ''}`}
                >
                  <td className={tableDataCellClass}>
                    <span className="inline-flex items-center gap-2">
                      <RunStatusDot status={r.status} />
                      <span className={failed ? 'text-danger' : ''}>{execStatusLabel(r.status)}</span>
                    </span>
                  </td>
                  <td className={`${tableDataCellClass} max-w-[220px]`}>
                    <span className="inline-flex max-w-full items-center gap-1.5" title={r.trigger_name ? `${meta.label}: ${r.trigger_name}` : meta.label}>
                      <TriggerIcon size={13} className="shrink-0 text-[color:var(--text-muted)]" aria-hidden />
                      <span className="truncate">{r.trigger_name || meta.label}</span>
                    </span>
                  </td>
                  <td className={`${tableDataCellClass} tabular-nums`}>{r.version_number != null ? `v${r.version_number}` : '—'}</td>
                  <td className={`${tableDataCellClass} tabular-nums`}>{r.steps_total ? `${r.steps_done ?? 0}/${r.steps_total}` : '—'}</td>
                  <td className={`${tableDataCellClass} tabular-nums`}>{formatDuration(r.duration_ms)}</td>
                  <td className={`${tableDataCellClass} whitespace-nowrap text-[color:var(--text-muted)]`} title={formatDate(r.started_at) || undefined}>{timeAgo(r.started_at) || '—'}</td>
                  <td className={`${tableDataCellClass} text-[color:var(--text-muted)]`}>{startedBy(r)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
